export default __webpack_public_path__ + "images/SJ.b4f76f4.png";